export enum UserTypeList {
    CUSTOMER = 'CUSTOMER',
    BUSINESS_OWNER = 'BUSINESS_OWNER'
}
